module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-05.6ffad916.png";